import _Model from "./_Model";

export default class TerminalBlockPreferences extends _Model {
  constructor(json) {
    super(json);
    this.cover = TerminalBlockPreferences.getOrDefault(json, 'cover', null);
    this.electricalConnection = TerminalBlockPreferences.getOrDefault(json, 'electricalConnection', null);
  }
}
